export default {
    path: 'businessapproval',
    component: () => import( /* webpackChunkName: "business-approval" */ '@/pages/business/approval'),
    meta: {
        title: '项目业务审批'
    }
}